import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import React from "react"
import { flatten, transpose } from "ramda"

type Props = {
    text: Maybe<string>
    highlight: Maybe<string>
    styleHighlight?: React.CSSProperties
    classNameHighlight?: string
}

/** Wrapping component for highlighting part of text/paragraph based on 'highlight' prop */
export const HighlightedText = (props: Props) => {
    if (!props.text) {
        return null
    }
    if (!props.highlight) {
        return <span>{props.text}</span>
    }

    const parts = splitByMatch(props.text, props.highlight)
    return (
        <span>
            {parts.map((p, idx) =>
                p.highlight ? (
                    <span key={p.text + idx} style={props.styleHighlight} className={props.classNameHighlight}>
                        {p.text}
                    </span>
                ) : (
                    <span key={p.text + idx}>{p.text}</span>
                )
            )}
        </span>
    )
}

export const escapeRegExp = (text: string): string => {
    return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}
type SplitPart = {
    text: string
    highlight: boolean
}

export const splitByMatch = (text: string, highlight: string): SplitPart[] => {
    const regexp = new RegExp(escapeRegExp(highlight), "gi")
    const splitParts: string[] = text.split(regexp) // split text string by search keyword

    const matchParts: Maybe<string[]> = text.match(regexp) // characters matching search keyword

    if (!matchParts) {
        return [
            {
                text: text,
                highlight: false,
            },
        ]
    }

    const splitPartsObjects = splitParts.map(r => ({
        text: r,
        highlight: false,
    }))
    const matchPartsObjects = matchParts.map(r => ({
        text: r,
        highlight: true,
    }))
    const input = [splitPartsObjects, matchPartsObjects]
    return flatten(transpose(input))
}
